import { render, staticRenderFns } from "./Resultado.vue?vue&type=template&id=1898f062&"
import script from "./Resultado.vue?vue&type=script&lang=js&"
export * from "./Resultado.vue?vue&type=script&lang=js&"
import style0 from "./Resultado.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports